<div class="nav-wrapper">
<app-navbar (headerPage)="openindex($event)" (howWorksPage)="openHowWorks($event)"></app-navbar>
</div>
